import { render } from "./VcgSolutionDetails.vue?vue&type=template&id=34ac6ad8&scoped=true"
import script from "./VcgSolutionDetails.vue?vue&type=script&lang=js"
export * from "./VcgSolutionDetails.vue?vue&type=script&lang=js"

import "./VcgSolutionDetails.vue?vue&type=style&index=0&id=34ac6ad8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34ac6ad8"]])

export default __exports__